import { isPro } from '@/utils/index.js';
const host = isPro() ? 'https://huituaccess.map.qq.com' : 'https://prehuituaccess.sparta.html5.qq.com';
// const host2 = isPro() ? 'https://galaxy.wsd.com' : 'https://zbtest.testsite.woa.com';

// 活动查询接口
export const activity_recruit = `${host}/ishare_activity/activity/recruit`;

// 用户报名接口
export const activity_sign = `${host}/ishare_activity/activity/recruit/sign`;

// 报名记录查询接口
export const activity_sign_list = `${host}/ishare_activity/activity/recruit/sign/record`;

// 用户退出 / 取消报名
export const activity_sign_cancel = `${host}/ishare_activity/activity/recruit/sign/cancel`

// 用户退出 / 取消报名
export const activity_sign_assigned = `${host}/ishare_activity/activity/recruit/task/assigned`

